import HttpClient from "@api/clients/httpClient";
import Restaurant from "../../restaurant/models/Restaurant";
import RestaurantOfferFilter from "../models/RestaurantOfferFilter";
import OfferBase from "../models/OfferBase";
import Food from "../models/Food";

const config = {
    endpoint: "restaurant-offers",
};

export default class RestaurantOfferService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new RestaurantOfferFilter());
    }

    getRestaurantsAsync = async (cityId: string) => {
        return await this.httpClient.findAsync<Restaurant[]>({}, {}, {}, {}, `city/${cityId}/restaurant`);
    }

    getFoodCategoriesAsync = async (restaurantId: string) => {
        return await this.httpClient.getAsync<OfferBase>('', {}, `restaurant/${restaurantId}/food-category`);
    }

    getFoodsAsync = async (foodCategoryId: string) => {
        return await this.httpClient.findAsync<Food[]>({}, {}, {}, {}, `food-category/${foodCategoryId}/food`);
    }

    getFoodsByNameAsync = async (restaurantId: string, foodName: string) => {
        return await this.httpClient.findAsync<Food[]>({}, {}, {}, {}, `restaurant/${restaurantId}/food/${foodName}`);
    }
}